<template>
  <div class="lottery-container" @click.prevent="" v-if="v && prizes.length>0">
    <!-- <lee-luck-draw v-if="prizes.length>0" ref="LuckDraw" :config="config" :prizes="prizes" :btnConfig="btnConfig"
      :arcStart="arcStart"
                   @start="startCallBack"
                   @end="endCallBack">
    </lee-luck-draw> -->
    <LwwLuckDraw v-if="prizes.length>0" ref="LuckDraw" :config="config" :prizes="prizes" :btnConfig="btnConfig"
      :arcStart="arcStart"
                   @start="startCallBack"
                   @end="endCallBack">
    </LwwLuckDraw>
    <div class="lottery-close-icon">
      <i class="el-icon-circle-close" @click="close"></i>
    </div>
  </div>
</template>

<script>
import LwwLuckDraw from './LwwLuckDraw.vue'
export default {
  components: { LwwLuckDraw },
  name: "lottery",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    uuid: {
      type: String,
      default: ""
    }
  },
  model: {
    prop: 'visible',
    event: 'changeLotteryVisible'
  },
  data() {
    return {
      v: this.visible,
      lotteryIndex: 0,
      luckyNum: 3,
      prizes: [],
      config: {
        width: 320,
        height: 320,
        padding: 20,
        fontSize: '20px',
        fontColor: '#d64737',
        backgroundColor: '#d64737',
      },
      arcStart:(2 * Math.PI /20 )*1  ,
      btnConfig: {
        width: '80',
        background: '#d64737',
        fonts: [
          {text: '开始', fontColor: '#fff', top: '50%', fontSize: '25px'},
          {text: '评论即可抽奖', fontColor: '#d64737', top: '25%', fontSize: '22px',fontWeight: '700',},
        ]
      },
    }
  },
  methods: {
    play(i) {
      this.lotteryIndex = i
      this.$refs.LuckDraw.play(i + 1)
    },
    startCallBack() {
      this.$emit('start')
    },
    endCallBack(inx) {
      this.btnConfig.fonts[0].text = '已抽奖'
      this.btnConfig.fonts[1].text = `恭喜抽中${this.prizes[this.lotteryIndex].fonts.text}`
    },
    close() {
      this.v = false
      this.$emit('changeLotteryVisible', this.v)
      this.$emit('close')
    }
  },
  watch: {
    visible(newValue) {
      this.v = newValue
    }
  },
  mounted() {
    //获取抽奖配置
    const _this = this
    $.ajax({
      url: serverUrl + "/system/dict/data/type/lottery_red_package",
      type: "get",
      success: function (data) {
        if (data.code == 200) {
          let arr = data.data
          for (let i = 0; i < arr.length; i++) {
            _this.prizes.push({
              fonts: {text: `${arr[i].dictValue}元红包`, top: '80%'},
              imgs: {src: '', width: '25%', top: '70%'},
              background: '#f9e3bb'
            })
          }
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.lottery-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.lottery-close-icon {
  color: #fff;
  font-size: 28px;
  cursor: pointer;
  margin-top: 8px;
}
</style>
